import axiosInstance from '@/services/axios.service';

export const passwordAPI = {
  /**
   * Запрос на сброс пароля
   * @param {string} email - Email пользователя
   * @returns {Promise} - Результат запроса
   */
  requestReset: async (email) => {
    const response = await axiosInstance.post(
      '/operator/password/request',
      { email },
      {
        baseURL: process.env.VUE_APP_SERVER_AUTH_URL,
      },
    );
    return response;
  },

  /**
   * Подтверждение сброса пароля с OTP
   * @param {string} email - Email пользователя
   * @param {string} otp - OTP код
   * @returns {Promise} - Результат запроса
   */
  resetPassword: async (email, otp) => {
    const response = await axiosInstance.post(
      '/operator/password/reset',
      { email, otp },
      {
        baseURL: process.env.VUE_APP_SERVER_AUTH_URL,
      },
    );
    console.log('resetPassword:passwordAPI:response', response);

    return response;
  },
};
